import { maxKeywordCount } from './constants/maximums';

export const parseKeywordString = (keywordString) => {
  const words = keywordString
    .split(',')
    .map(word => word.trim());
  return words;
};

export const sortByName = i18n => (a, b) => {
  if (i18n.getString(a.name) < i18n.getString(b.name)) {
    return -1;
  }

  if (i18n.getString(b.name) < i18n.getString(a.name)) {
    return 1;
  }

  return 0;
};

export const getUETTags = (wizardData) => {
  if (wizardData.useVisitConversionLift && wizardData.useConversionLift && wizardData.useVisitLift) {
    return wizardData.uetTags.both;
  } else if (wizardData.useConversionLift) {
    return wizardData.uetTags.conversion;
  } else if (wizardData.useVisitLift) {
    return wizardData.uetTags.visit;
  }
  return undefined;
};

export const getKeywords = (wizardData) => {
  if (!wizardData.keywordsMethod || !wizardData.useSearchLift) {
    return undefined;
  }
  return wizardData.keywordsMethod === 'entry'
    ? parseKeywordString(wizardData.typedKeywordString)
        .filter(kw => kw.length > 0)
        .slice(0, maxKeywordCount)
    : wizardData.selectedKeywords.map(keywordId => wizardData.fetchedKeywords[keywordId].name);
};
